import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        {/* <span><a href="#">Murat Lamm Admin</a> &copy; 2020 Waffleworld.com</span> */}
        <span className="ml-auto">
          Powered by{" "}
          <a href="https://algebra-informatics.com/">Algebra Informatics</a>
        </span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js